import { cn } from '@/lib/utils';

/** Simple shimmer rectangle for loading states. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn('animate-pulse rounded-md bg-muted/70', className)}
    />
  );
}

/** Skeleton list for the ticket sidebar. */
export function TicketListSkeleton() {
  return (
    <ul className="divide-y" aria-label="Loading tickets">
      {Array.from({ length: 6 }).map((_, i) => (
        <li key={i} className="p-4 space-y-2">
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-2 w-1/3" />
        </li>
      ))}
    </ul>
  );
}
